import { Injectable } from '@angular/core';

@Injectable()
export class RealTimeService {
  equipmentLocation: Map<string, Array<object>> = new Map();
  apolloClient: any; // aggiorna il tipo se necessario

  constructor() {}

  parseML = (machineLocation) => {
    let result = null;
    let result1 = null;
    let result2 = null;
    try {
      result1 = JSON.parse(machineLocation);
      result = result1;
      try {
        result2 = JSON.parse(result1);
        result = result2;
      } catch (e) {
        result = result1;
        console.error(e);
      }
    } catch (e) {
      result = null;
      console.error(e);
    }
    return result;
  };

  setLocationForEquipmentMap(machineLocation) {
    const ml = this.parseML(machineLocation);
    if (ml && ml.externalId) {
      const existInMap = this.equipmentLocation.get(ml.externalId);
      if (existInMap) {
        existInMap.push(ml);
        this.equipmentLocation.set(ml.externalId, existInMap);
      } else {
        this.equipmentLocation.set(ml.externalId, [ml]);
      }
    }
  }

  getLocationForEquipment(equipmentId) {
    return this.equipmentLocation.get(equipmentId);
  }

  cleanLocationForEquipment(equipmentId) {
    this.equipmentLocation.set(equipmentId, []);
  }

  closeRealTimeConnection() {
    if (this.apolloClient.wsClient) {
      this.apolloClient.wsClient.unsubscribeAll();
      this.apolloClient.wsClient.close();
      this.equipmentLocation = new Map();
    }
  }
}
